module.exports = __webpack_public_path__ + "static/Cruzadas-03bee29d1ce76654b7dd0b4e7a9e98c0.jpg";